import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FunctionOutlinedSvg from "@ant-design/icons-svg/es/asn/FunctionOutlined";
import AntdIcon from "../components/AntdIcon";
var FunctionOutlined = function FunctionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FunctionOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FunctionOutlined.displayName = 'FunctionOutlined';
}
export default /*#__PURE__*/React.forwardRef(FunctionOutlined);